import { ChakraSimpleGrid as SimpleGrid } from "@airhelp/react-ui-components";
import { Container } from "components/Container";
import type { SbEditableComponentProps } from "types/storyblok";
import { PartnerCard } from "./PartnerCard";
import type { PartnerCardsProps } from "./PartnerCards.d";

export const PartnerCards = ({ cards, itemsInRow, sbEditable }: SbEditableComponentProps<PartnerCardsProps>) => (
  <Container>
    <SimpleGrid
      columns={{ base: 1, md: 2, lg: Number(itemsInRow) }}
      gridGap={{ base: 4, lg: 8 }}
      justifyItems="center"
      px={{ base: 4, xl: 0 }}
      {...sbEditable}
    >
      {cards?.map(({ logoUrl, content, _uid, logoBackgroundColor, partnerLink }) => (
        <PartnerCard
          key={_uid}
          logoUrl={logoUrl}
          content={content}
          logoBackgroundColor={logoBackgroundColor}
          partnerLink={partnerLink}
        />
      ))}
    </SimpleGrid>
  </Container>
);
